import type { LinkChallengeInfo } from '@draughts/shared';
import { api } from './api';

/**
 * Read a shared challenge link. The endpoint is public: the friend arriving
 * from WhatsApp is normally logged out, and the socket only connects once
 * authenticated, so this is what fills the invite screen before they decide to
 * play (as a guest or with an account).
 *
 * Returns null when the link is unknown — expired long ago, cancelled and
 * forgotten, or created before a server restart.
 */
export async function fetchChallengeLink(id: string): Promise<LinkChallengeInfo | null> {
  try {
    const res = await api.get<{ link: LinkChallengeInfo }>(`/challenges/link/${encodeURIComponent(id)}`);
    return res.link ?? null;
  } catch {
    return null;
  }
}
